<template>
    <div class="createKey">
        <van-nav-bar v-if="$route.query.isApp != 1" :title="$t('9100163')" left-arrow @click-left="goHome()" />
        <div class="commont_body">
            <form class="tabForm">
                <div class="form-item">
                    <!-- 备注名 -->
                    <div class="label">{{$t('9100128')}} <span>*</span></div>
                    <!-- 9100129  请输入备注名 -->
                    <input v-model="formData.note" :placeholder="$t('9100129')" @blur="e => (checkForm.note = !e.target.value)" />
                    <div class="rule" v-if="checkForm.note">{{$t('9100129')}}</div>
                </div>
                <div class="form-item">
                    <!-- 9100130 权限设置 (可多选)  -->
                    <div class="label">{{$t('9100130')}}</div>
                    <van-checkbox-group v-model="formData.result" style="width: 100%; display: flex;">
                        <!-- 9100131  读取 -->
                        <van-checkbox name="a" checked disabled shape="square">{{$t('9100131')}}</van-checkbox>
                        <!-- 交易 -->
                        <van-checkbox class="noDisabledCheack" name="b" shape="square" checked-color="#FFC72B">{{$t('9100132')}}</van-checkbox>
                    </van-checkbox-group>
                </div>
                <div class="form-item">
                    <!-- 绑定IP地址 (选填) -->
                    <div class="label">{{$t('9100133')}}</div>
                    <!-- 9100134  多个IP地址请用英文逗号隔开 , 最多填写10个IP地址 -->
                    <textarea name="" id="" cols="30" rows="10" :placeholder="$t('9100134')" v-model="formData.whiteList"></textarea>
                    <!-- IP地址格式不正确 -->
                    <div class="rule" v-if="checkIp">{{$t('9100171')}}</div>
                </div>
            </form>

            <div class="foot-list">
                <!-- 300166  提示 -->
                <div class="title">{{$t('300166')}}</div>
                <div class="item">
                    <span>·</span>
                    <!-- SuperEx为您提供了强大的API，您可以通过API使用行情查询、自动交易等服务。通过
          <a>API 文档</a> 查看如何使用。 -->
                    <p v-html="$t('9100138')"></p>
                </div>
                <div class="item">
                    <span>·</span>
                    <!-- 每个用户最多创建10组API key -->
                    {{$t('9100139')}}
                </div>
                <div class="item">
                    <span>·</span>
                    <!-- <strong>请不要泄露您的API key，以免造成资产损失。</strong
          >出于安全考虑，建议为API key绑定IP，每个API
          key最多绑定10个IP地址。单个IP地址直接填写，多个IP地址用半角逗号分隔，如：192.168.1.1,192.168.1.2 -->
                    <p><span style="font-weight:600;">{{$t('9100147')}}</span>{{$t('9100148')}}</p>

                </div>
                <div class="item">
                    <span>·</span>
                    <!-- 未绑定IP的API key，将在90天后自动失效。如长期使用，您可在下方“我的API
          key - 操作 - 续签”，将您的API key有效期顺延90天。已绑定IP的API
          key无有效期限制。 -->
                    <p>{{$t('9100140')}}</p>
                </div>
            </div>
        </div>
        <div class="footer editFooter" v-if="pageData && pageData.id">
            <div class="edit-button">
                <!-- 300111 取消 -->
                <van-button class="cancel" color="rgba(0, 0, 0, 0.10)" @click="$router.go(-1)">{{$t('300111')}}</van-button>
                <!-- 编辑  9100164 -->
                <van-button :color="editDisabled ? 'rgba(0, 0, 0, 0.10)' : '#FFC72B'" @click="editForm" :disabled="editDisabled">{{$t('9100164')}}</van-button>
            </div>
        </div>
        <div class="footer" v-else-if="!$route.query.id">
            <div class="check">
                <van-checkbox v-model="checked" name="b" shape="square" checked-color="#FFC72B">
                    <!-- 我已阅读并同意 -->
                    <!-- {{$t('9100135')}} -->
                    <!-- <span style="color:red">{{$t('9100135')}}</span> -->
                </van-checkbox>
                <!-- 我已阅读并同意 -->
                <p>
                    {{$t('9100135')}}
                    <span @click="isRiskTip = true">
                        <!-- 我已阅读并同意【API用户风险提示】 -->
                        {{$t('9100170')}}
                    </span>
                </p>
            </div>
            <!-- <div class="rule" v-if="checked === false" style="margin-bottom: .3rem;">
        请勾选API用户风险提示
      </div> -->
            <div class="buttons">
                <!-- <van-button type="info" size="large" @click="$router.go(-1)"
          >取消</van-button> -->
                <van-button type="info" :color="createDisabled ? changeBgColor : '#FFC72B'" size="large" @click="createForm" :disabled="createDisabled">
                    <!-- 创建 -->
                    <span :style="createdBtn">{{$t('9100137')}}</span>
                </van-button>
            </div>
        </div>

        <van-popup class="tipModel" :close-on-click-overlay="false" v-model="Showprice">
            <p class="p">
                <svg>
                    <use xlink:href="#icon-tishi-1" />
                </svg>
            </p>
            <p class="describe inline-block">
                <!-- 创建API Key需要您向现货钱包充值任意金额激活账户 -->
                {{$t('9100145')}}
            </p>
            <div class="sell inline-block">
                <van-button @click="goChargemoney">{{
          $t("300102")
        }}</van-button>
            </div>
        </van-popup>

        <van-popup class="tipModel" :close-on-click-overlay="false" v-model="isRiskTip">
            <p class="modal-title">
                <svg>
                    <use xlink:href="#icon-tishi-2" />
                </svg>
                <!-- 9100154  风险提示 -->
                <span>{{$t('9100154')}}</span>
            </p>
            <div class="modal-content">
                <!-- 9100151  您需要了解以下风险： -->
                <div>{{$t('9100151')}}</div>
                <div>
                    <!-- · API Key跟您的账号安全紧密相关，凡知晓您API
          Key的第三方均有可能控制您账户资产，因此请您妥善保管，请不要向任何第三方透露您的API
          Key，并不上传至第三方网站和论坛 -->
                    · {{$t('9100152')}}
                </div>
                <div>
                    <!-- · 因您个人原因导致API
          Key泄露而涉及的包括但不限于资产安全问题、经济损失问题等，您自行承担由此产生的全部责任，我们不对此承担责任。 -->
                    · {{$t('9100153')}}
                </div>
            </div>
            <div class="sell">
                <van-button @click="
            () => {
              isRiskTip = false;
              checked = true;
            }
          ">
                    <!-- 我已知悉并愿意承担风险 -->
                    {{$t('9100155')}}
                </van-button>
            </div>
        </van-popup>
        <van-popup v-model="verificationModel" class="tipModel">
            <verification :isGoogle="!!resultObj.is2FA" :type="resultObj.is2FA ? 'google' :user.email
                 ? 'email': 'phone'" interfaceType='online' :validationToken="resultObj.validationToken" :userName="resultObj.is2FA ? '': user.email ? user.email : user.phone" @submitFun="submitFun" @backFun="backFun" :isGeet="false"></verification>
        </van-popup>
    </div>
</template>

<script>
    import {
        List,
        Icon,
        NavBar,
        Button,
        Collapse,
        CollapseItem,
        CheckboxGroup,
        Checkbox,
        Popup,
        Toast
    } from "vant";
    import { parseTime } from "@/utils/index";
    import { Empty } from "vant";
    import { mapGetters } from "vuex";
    import {
        addApiKey,
        isFirtsRecharge,
        queryApiKey,
        editApiKey
    } from "@/api/apikey";
    import verification from "@/compontents/verification";
    import { setToken, getCookie, removeToken, setCookie } from '../../utils/auth'

    export default {
        name: "apiKey",
        components: {
            vanList: List,
            vanIcon: Icon,
            vanEmpty: Empty,
            vanNavBar: NavBar,
            verification,
            [Button.name]: Button,

            [Collapse.name]: Collapse,
            [CollapseItem.name]: CollapseItem,
            [CheckboxGroup.name]: CheckboxGroup,
            [Checkbox.name]: Checkbox,
            [Popup.name]: Popup
        },
        data() {
            return {
                activeNames: ["1"],
                checked: "",
                isRiskTip: false,
                formData: {
                    note: "",
                    result: ["a"],
                    whiteList: ""
                },
                resultObj: {},
                step2Data: {},
                Showprice: false,
                verificationModel: false,
                pageData: {},
                isFirtsRecharge: false,
                requestLocked: false,
                checkForm: {
                    note: false,
                    whiteList: false
                }
                // createDisabled: true
            };
        },
        watch: {
            $route() {
                this.resher()
            },
        },
        created() {
            console.log(this.$route.query, 'this.$route.query---this.$route.query');
            this.resher()
            if (this.$route.query && this.$route.query.id) {
                this.getPageList();
            }
        },
        computed: {
            ...mapGetters(["isDirection", "user"]),
            createDisabled() {
                return !(
                    !this.checkForm.note &&
                    this.checked &&
                    this.formData.note &&
                    !this.checkIp
                );
            },
            changeBgColor() {
                if (this.$route.query.backgroundColor === "day") {
                    return 'rgba(0, 0, 0, 0.10)'
                } else {
                    return 'rgba(255, 255, 255, 0.05)'
                }
            },
            createdBtn() {
                if (this.createDisabled) {
                    console.log('禁用');
                    if (this.$route.query.backgroundColor === "day") {
                        return 'color:rgba(0, 0, 0, 0.40);'
                    } else {
                        return 'color:rgba(255, 255, 255, 0.45);'
                    }
                } else {
                    return 'color:rgba(0, 0, 0, 0.90);'
                }
            },
            editDisabled() {
                return !(!this.checkForm.note && this.formData.note && !this.checkIp);
            },
            checkIp() {
                if (!this.formData.whiteList) {
                    return;
                }
                const regex = /^(\b25[0-5]\b|\b2[0-4][0-9]\b|\b1[0-9]{2}\b|\b[1-9]?[0-9]\b)(\.(\b25[0-5]\b|\b2[0-4][0-9]\b|\b1[0-9]{2}\b|\b[1-9]?[0-9]\b)){3}(,(\b25[0-5]\b|\b2[0-4][0-9]\b|\b1[0-9]{2}\b|\b[1-9]?[0-9]\b)(\.(\b25[0-5]\b|\b2[0-4][0-9]\b|\b1[0-9]{2}\b|\b[1-9]?[0-9]\b)){3}){0,9}$/;
                return !regex.test(this.formData.whiteList);
            }
        },
        methods: {
            resher() {
                this.isApp = this.$route.query.isApp
                let token = this.$route.query.token || this.token
                if (token) {
                    setToken(token);
                    this.$store.dispatch('GetInfo', token);
                    this.$store.dispatch('setToken', token);
                }
                this.$i18n.locale = this.$route.query.language ? this.$route.query.language : 'en'
                setCookie(
                    'language',
                    this.$route.query.language ? this.$route.query.language : 'en'
                )
                this.language = this.$route.query.language
                    ? this.$route.query.language
                    : 'en'
                this.$store.dispatch(
                    'setIsDirection',
                    this.$route.query.language == 'fa' ? true : false
                )
                if (this.$route.query.backgroundColor != "") {
                    window.document.documentElement.setAttribute(
                        "data-theme",
                        this.$route.query.backgroundColor === "day" ? "sunlight" : "moon"
                    );
                } else {
                    window.document.documentElement.setAttribute("data-theme", "moon");
                }
                window.document.documentElement.setAttribute(
                    'dir',
                    this.isDirection ? 'rtl' : 'ltr'
                )
            },
            // validateIPList(ipList) {
            // return regex.test(ipList);
            // },
            goChargemoney() {
                if (this.$route.query.isApp == 1) {
                    this.$jsBridge.callHandler(this.$jsBridgeCmd.appRecharge, { code: 200 }, (data) => { })
                } else {
                    this.$router.push({
                        path: `/download`,
                        query: {
                            backgroundColor: this.$route.query.backgroundColor,
                            language: this.$route.query.language,
                            isApp: this.$route.query.isApp
                        }
                    });
                }
            },
            backFun() {
                this.verificationModel = false
            },
            goHome() {
                this.$router.push({
                    path: `/apikey`,
                    query: {
                        backgroundColor: this.$route.query.backgroundColor,
                        language: this.$route.query.language,
                        isApp: this.$route.query.isApp
                    }
                });
            },
            async createForm() {
                console.log(this.user, 'user===user');
                const res = await isFirtsRecharge();
                if (res.code !== 200) {
                    this.Showprice = true;
                    return;
                }
                try {
                    const res1 = await addApiKey({
                        note: this.formData.note,
                        whiteList: this.formData.whiteList,
                        freeSpotState: this.formData.result.length > 1 ? 1 : 0,
                        step: 1
                    });
                    console.log(res1, 'res1---res1');

                    if (res1.code == 500) {
                        Toast(res1.msg)
                    } else {
                        this.resultObj = {
                            email: this.user.email,
                            token: res1.data.token,
                            step: 2,
                            is2FA: res1.data.is2FA
                        };
                        this.verificationModel = true;
                    }
                } catch (err) {
                    // console.log(error, "resultObj");
                }
            },
            async submitFun(code, type) {
                console.log(code, type, "123");
                console.log(this.pageData, 'pageData---pageData');

                if (this.pageData && this.pageData.id) {
                    console.log('走编辑了吗');
                    //编辑
                    if (this.requestLocked) {
                        return;
                    }
                    this.requestLocked = true;
                    delete this.resultObj.email;
                    try {

                        const params = {
                            note: this.formData.note,
                            whiteList: this.formData.whiteList,
                            freeSpotState: this.formData.result.length > 1 ? 1 : 0,
                        }

                        type == "google" ? (params.googleCode = code) : (params.validationCode = code)
                        const editRes = await editApiKey(this.$route.query.id, params);
                        this.step2Data = editRes.data;
                        console.log(editRes.code, 'editRes===editRes');

                        if (editRes.code != 200) {
                            console.log(editRes, 'cccccccccccccccccccccccccccc');
                            Toast(editRes.msg)
                            this.requestLocked = false
                            return
                        }
                        this.requestLocked = false;
                        this.verificationModel = false;
                        Toast(editRes.msg);
                        this.$router.go(-1);
                    }
                    catch (err) {
                        console.log(err, '呵呵');
                    }
                } else {
                    console.log('走创建了吗');
                    //创建
                    if (this.requestLocked) {
                        return;
                    }
                    this.requestLocked = true;
                    delete this.resultObj.email;
                    let cc = {}
                    try {
                        if (type == "google") {
                            cc = await addApiKey({
                                ...this.resultObj,
                                googleCode: code
                            });
                            this.step2Data = cc.data;
                        } else {
                            cc = await addApiKey({
                                ...this.resultObj,
                                validationCode: code
                            });
                            this.step2Data = cc.data;
                        }
                        if (cc.code != 200) {
                            console.log(cc, 'cccccccccccccccccccccccccccc');
                            Toast(cc.msg)
                            this.requestLocked = false
                            return
                        }
                        this.requestLocked = false;
                        this.verificationModel = false;
                        console.log(this.step2Data, "step2Datastep2Data");
                        this.$router.push({
                            path: `/apiKeySuccess`,
                            query: {
                                accessSecret: this.step2Data.accessSecret,
                                accessKey: this.step2Data.accessKey,
                                backgroundColor: this.$route.query.backgroundColor,
                                language: this.$route.query.language,
                                isApp: this.$route.query.isApp
                            }
                        });
                    }
                    catch (err) {
                        console.log(err, '呵呵');
                    }
                }
            },
            async editForm() {
                this.verificationModel = true
                this.resultObj = {
                    email: this.user.email,
                    // token: res1.data.token,
                    step: 2,
                    is2FA: this.user.isGoogleOpened
                };

                // await editApiKey(this.$route.query.id, {
                //     note: this.formData.note,
                //     whiteList: this.formData.whiteList,
                //     freeSpotState: this.formData.result.length > 1 ? 1 : 0,
                // });
                // Toast("编辑成功");
                // this.$router.go(-1);
            },
            async getPageList() {
                const { data } = await queryApiKey();
                this.pageData =
                    (data && data.length && data.find(i => i.id == this.$route.query.id)) ||
                    [];

                this.formData = {
                    note: this.pageData.note,
                    result: this.pageData.freeSpotState == 1 ? ["a", "b"] : ["a"],
                    whiteList: this.pageData.whiteList
                };
            },
            checkBlur(e) {
                const value = e.target.value;
                this.checkForm.whiteList = !this.validateIPList(value);
                console.log(this.checkForm.whiteList, "this.checkForm.whiteList");
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "../../assets/css/variableName";
    @import "../../style/mixin";
    @import "../../assets/css/mixin";
    .tipModel .p{
        display: flex;
        justify-content: center;
    }
    .createKey {
        overflow: hidden;
        width: 100%;
        height: 100vh;
        @include background_color("background-color-2");
        /deep/ .van-nav-bar__content {
            @include background_color("background-color-10");
            height: torem(44);
        }
        /deep/ .van-nav-bar__title {
            @include font_color("font-color");
            // color: red;
        }
        /deep/ .van-nav-bar .van-icon {
            @include font_color("font-color");
        }
        /deep/ .van-hairline--bottom::after {
            @include border_color("border-color-6");
        }
        .commont_body {
            padding: torem(16);
            padding-bottom: torem(120);
            overflow-y: auto;
            width: 100%;
            height: calc(100vh - 50px);
            .tabForm {
                .form-item {
                    width: 100%;
                    margin-bottom: torem(20);
                    .label {
                        @include font_color("font-color");

                        font-family: "HarmonyOS Sans SC";
                        font-size: torem(14);
                        font-style: normal;
                        font-weight: 400;
                        line-height: normal;
                        margin-bottom: torem(12);
                        span {
                            color: #f65d62;
                        }
                    }
                    input {
                        width: 100%;
                        border-radius: 8px;
                        border: 2px solid;
                        height: torem(44);
                        padding-left: torem(12);
                        @include background_color("background-color-11");
                        @include border_color("border-color-5");
                        @include font_color("font-color");
                    }

                    textarea {
                        width: 100%;
                        border-radius: 8px;
                        border: 2px solid rgba(0, 0, 0, 0.05);
                        padding-top: torem(16);
                        padding-left: torem(12);
                        @include background_color("background-color-11");
                        @include border_color("border-color-5");
                        @include font_color("font-color");
                        line-height: torem(14);
                    }
                    textarea::placeholder {
                        line-height: torem(14);
                    }
                    /deep/ .van-checkbox__label {
                        margin-right: torem(16);
                        @include font_color("font-color");
                    }
                    .noDisabledCheack {
                        /deep/ .van-checkbox__icon--checked .van-icon {
                            color: #191406;
                        }
                    }
                }
            }
            .foot-list {
                border-radius: 16px;
                background: rgba(226, 231, 239, 0.2);
                width: 100%;
                padding: torem(12);
                .title {
                    @include font_color("font-color-13");
                    font-family: "HarmonyOS Sans SC";
                    font-size: torem(14);
                    font-style: normal;
                    font-weight: 500;
                    line-height: 150%; /* 42px */
                    letter-spacing: 2px;
                    margin-bottom: torem(8);
                }
                .item {
                    display: flex;
                    span {
                        margin-right: torem(8);
                    }
                    @include font_color("disale-color");

                    margin-bottom: torem(8);
                    font-family: "HarmonyOS Sans SC";
                    font-size: torem(12);
                    font-style: normal;
                    font-weight: 400;
                    line-height: 150%; /* 36px */
                    a {
                        // color: #366ef4;
                        text-decoration-line: underline !important;
                    }
                }
            }
        }
    }

    .footer {
        width: 100%;
        padding: torem(16);
        position: fixed;
        bottom: 0;
        left: 0;
        border-top: 2px solid rgba(0, 0, 0, 0.05);
        z-index: 999;
        @include background_color("background-color-2");
        .buttons {
            display: flex;
        }
        .check {
            display: flex;
            margin-bottom: torem(8);
            align-items: center;
            span {
                margin-left: torem(6);
                color: #d1a53e;
                font-family: "HarmonyOS Sans SC";
                // font-size: 28px;
                font-style: normal;
                font-weight: 400;
                line-height: 150%; /* 42px */
                letter-spacing: 2px;
                text-decoration-line: underline !important;
            }
            p {
                margin-left: torem(6);
                font-family: "HarmonyOS Sans SC";
                @include font_color("font-color");
                // font-size: 28px;
                font-style: normal;
                font-weight: 400;
                line-height: 150%; /* 42px */
                letter-spacing: 2px;
                flex: 1;
            }
            /deep/ .van-checkbox__icon--checked .van-icon {
                color: #191406;
            }
            // TODO
            /deep/ .van-checkbox {
                .van-checkbox__label {
                    @include font_color("font-color");
                }
            }
        }
    }
    .editFooter {
        padding: torem(12) torem(10);
    }

    .tipModel {
        // /deep/ .van-popup {
        @include background_color("background-color-13");
        width: calc(100% - 2rem);
        min-height: torem(204);
        border-radius: torem(8);
        padding: torem(24);
        .p {
            text-align: center;
            svg {
                width: torem(48);
                height: torem(48);
            }
        }
        .describe {
            @include font_color("font-color");

            text-align: center;
            font-feature-settings: "clig" off, "liga" off;
            font-family: "HarmonyOS Sans SC";
            // font-size: 28px;
            font-style: normal;
            font-weight: 400;
            line-height: 150%; /* 42px */
            font-size: torem(14);
            margin: torem(24) 0;
        }
        .recharge {
            font-size: torem(14);
            width: 100%;
            line-height: torem(21);
            height: torem(21);
            margin: torem(16) 0 torem(24);
            text-align: center;
        }
        .sell {
            width: 100%;
            /deep/ .van-button {
                // width: torem(264);
                width: 100%;
                height: torem(44);
                background: #ffc72b;
                border-radius: torem(4);
                font-size: torem(16);
                border-color: transparent;
                color: #191406;
            }
        }
        .modal-title {
            display: flex;
            align-items: center;
            justify-content: center;

            svg {
                width: torem(16);
                height: torem(16);
                margin-right: torem(8);
            }
            span {
                @include font_color("font-color");

                font-family: "HarmonyOS Sans SC";
                font-size: torem(16);
                font-style: normal;
                font-weight: 500;
                line-height: normal;
            }
        }
        .modal-content {
            display: flex;
            flex-direction: column;
            @include font_color("font-color");
            font-feature-settings: "clig" off, "liga" off;
            font-family: "HarmonyOS Sans SC";
            font-size: torem(14);
            font-style: normal;
            font-weight: 400;
            line-height: 150%; /* 42px */
            margin: torem(24) 0;
            div {
                margin: torem(4) 0;
            }
        }
    }
    .rule {
        color: #f65d62;
        font-family: "HarmonyOS Sans SC";
        font-size: torem(12);
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-top: torem(4);
    }

    /deep/ .van-checkbox__icon {
        font-size: 0.8rem;
    }
    /deep/ .van-checkbox__label--disabled {
        @include font_color("font-color");
    }

    /deep/ .van-checkbox__icon--checked .van-icon {
        @include font_color("font-color");
    }

    /deep/ .van-checkbox__icon--disabled.van-checkbox__icon--checked .van-icon {
        color: #ffffff;
        background-color: rgba(0, 0, 0, 0.6);
    }
    /deep/ .van-button--info {
        @include font_color("font-color");

        border-radius: 8px;
    }
    .edit-button {
        display: flex;
        align-items: center;
        justify-content: space-between;

        button {
            flex: 1;
            margin: 0 torem(8);
            color: rgba(0, 0, 0, 0.9) !important;
        }
        .cancel /deep/ .van-button__text {
            @include font_color("font-color");
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/apiKey/createKey.vue